var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptions = function SvgOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".options_svg__a_V9IE6Q1T{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "options_svg__a_V9IE6Q1T",
    d: "M0 0h44v44H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "options_svg__a_V9IE6Q1T",
    d: "M10 10h24v24H10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 4a2 2 0 1 0-2-2 2.006 2.006 0 0 0 2 2Zm0 2a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2Zm0 6a2 2 0 1 0 2 2 2.006 2.006 0 0 0-2-2Z",
    transform: "rotate(90 5 25)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgOptions;